import { useEffect, useState } from "react";
import { apiGet, apiPost } from '../../API/httpCommon';
import { getUserDetails } from '../../Utility/UserUtility';
import Spinner from '../Spinner/Spinner';
import $, { event } from "jquery";
import { AddUpdateCart, GetCart,RemoveAllItemFromCart } from '../../Utility/CartUtility';
import { buffer } from "stream/consumers";
import { BrowserRouter as Router, Route, useParams } from 'react-router-dom';
import { format, addDays } from 'date-fns';


const OrderResponse = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { OrderId } = useParams();
    const [OrderData, setOrderData] = useState<any>();
    const [Order_Date, setOrder_Date] = useState<any>();
    const [EstimatedDeliveryDate, setEstimatedDeliveryDate] = useState<any>(null);


    useEffect(function () {
        
        const userAgent = navigator.userAgent;
        let plateForm: string = '';

        if (userAgent.match(/Windows NT/i) || userAgent.match(/Macintosh/i) || userAgent.match(/Linux/i)) {
            plateForm = 'Website';

        } else if (userAgent.match(/Android/i) || userAgent.match(/iPhone|iPad|iPod/i)) {
            plateForm = 'MobileWebiste';
        } else {
            plateForm = 'Unknown';
        }

        

        GetData(OrderId, plateForm);

    }, []);

    const GetData = (OrderId: any, plateForm: any) => {
        
        setIsLoading(true);
        let userDetails = getUserDetails();
        apiGet("api/PlaceOrder/OrderResponse?OrderId=" + OrderId + "&OrderFrom=" + plateForm).then((res: any) => {
            
            RemoveAllItemFromCart();
            $("#CartText").text(0);
            if (res.Data !== null) {
                setOrderData(res.Data);
                let formattedDate = format(res?.Data?.Order_Date, 'dd-MMM-yyyy, h:mm:ss a');
                setOrder_Date(formattedDate)
                let NewEstimatedDeliveryDate = format(addDays(formattedDate, 7), 'dd-MMM-yyyy, h:mm:ss a');
                setEstimatedDeliveryDate(NewEstimatedDeliveryDate)
            }
            setIsLoading(false);
        });

    }



    return (<>
        {(isLoading && <Spinner></Spinner>)}
        {/* <!-- Breadcumb Section Start --> */}
        <div className=" breadcrumb-padding-180"></div>
        <div className="userbreadcum">
            <div className="container">
                <div className="row ">
                    <div className="col-xl-8">
                        <h1>Order ID: {OrderId}</h1>
                        <h3 style={{ lineHeight: "70px" }}>Order Date: {Order_Date} &nbsp;&nbsp; <i className="fa-solid fa-shipping-fast" style={{ color: "#004aad" }}></i> &nbsp;&nbsp; <span style={{ color: "#00bf63" }}>Estimated Delivery Date: {EstimatedDeliveryDate}</span></h3>
                    </div>
                    {/* <div className="col-xl-4">
				<a className="theme-btn" href="#" style={{background:"#ffffff", color:"#000000", border:"1px solid#000000"}}>Invoice </a>&nbsp;&nbsp;&nbsp;
				<a className="theme-btn" href="#" style={{background:"#00bf63", border:"1px solid#000000"}}>Track Order </a>
				</div> */}
                </div>
            </div>
        </div>


        {/* <!-- Shop Cart Section Start --> */}
        <div className="cart-section section-padding">
            <div className="container">
                <div className="main-cart-wrapper">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="row">
                                <div className="col-xl-8">
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th className="cart-border-none" style={{ width: "400px" }}>Item Name</th>
                                                    <th className="cart-border-none" style={{ width: "100px", textAlign: "center" }}>Qty</th>
                                                    <th className="cart-border-none" style={{ width: "170px" }}>Price</th>
                                                    <th className="cart-border-none" style={{ width: "170px" }}>Total</th>
                                                </tr>

                                            </thead>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-xl-4"></div>
                            </div>




                        </div>
                        <div className="border-bottom"></div>
                        <div className="col-xl-8">
                            <div className="table-responsive">

                                <table className="table">
                                    <tbody>
                                        {
                                            OrderData?.ItemList?.map((item: any, index: any) => (
                                                <tr>
                                                    <td className="cart-border-none" style={{ width: "400px" }}>
                                                        <span className="d-flex gap-5 align-items-center">

                                                            <span className="cart-title">
                                                                {item?.Item_Title}
                                                            </span>
                                                        </span>
                                                    </td>

                                                    <td className="cart-border-none" style={{ width: "100px", textAlign: "center" }}>
                                                        <span className="cart-price"> {item?.Item_Quantity}</span>
                                                    </td>
                                                    <td className="cart-border-none" style={{ width: "170px" }}>
                                                        <span className="cart-price">₹ {item?.Item_Price}</span>
                                                    </td>
                                                    <td className="cart-border-none" style={{ width: "170px" }}>
                                                        <span className="d-flex gap-5 align-items-center">
                                                            <span className="subtotal-price">₹ {item?.Sub_Total}</span>
                                                        </span>

                                                    </td>
                                                </tr>
                                            ))
                                        }


                                        {/* <tr>

                                            <td className="cart-border-none" style={{ width: "400px" }}>
                                                <span className="d-flex gap-5 align-items-center">

                                                    <span className="cart-title">
                                                        Diagnostic Ultrasound, 2-Volume Set

                                                    </span>
                                                </span>
                                            </td>

                                            <td className="cart-border-none" style={{ width: "100px", textAlign: "center" }}>

                                                <span className="user-qty">1</span>
                                            </td>
                                            <td className="cart-border-none" style={{ width: "170px" }}>
                                                <span className="cart-price">₹ 28428.00</span>
                                            </td>
                                            <td className="cart-border-none" style={{ width: "170px" }}>
                                                <span className="d-flex gap-5 align-items-center">
                                                    <span className="subtotal-price">₹ 28428.00</span>

                                                </span>

                                            </td>
                                        </tr>
                                        <tr>

                                            <td className="cart-border-none" style={{ width: "400px" }}>
                                                <span className="d-flex gap-5 align-items-center">

                                                    <span className="cart-title">
                                                        Diagnostic Ultrasound, 2-Volume Set

                                                    </span>
                                                </span>
                                            </td>

                                            <td className="cart-border-none" style={{ width: "100px", textAlign: "center" }}>

                                                <span className="user-qty">1</span>
                                            </td>
                                            <td className="cart-border-none" style={{ width: "170px" }}>
                                                <span className="cart-price">₹ 28428.00</span>
                                            </td>
                                            <td className="cart-border-none" style={{ width: "170px" }}>
                                                <span className="d-flex gap-5 align-items-center">
                                                    <span className="subtotal-price">₹ 28428.00</span>

                                                </span>

                                            </td>
                                        </tr> */}



                                    </tbody>
                                </table>

                            </div>

                        </div>
                        <div className="col-xl-4">
                            <div className="product-checout-area">
                                {/* <div className="checkout-item d-flex align-items-center justify-content-between">
                                    <p><b>Subtotal:</b></p>
                                    <p><b>₹ {OrderData?.Order_Amount}</b></p>
                                </div>
                                <div className="checkout-item d-flex align-items-center justify-content-between">
                                    <p><b>Shipping:</b></p>
                                    <p><b>₹ 0</b></p>
                                </div>
                                <div className="checkout-item d-flex align-items-center justify-content-between">
                                    <p><b>Discount:</b></p>
                                    <p><b>₹ 0</b></p>
                                </div>
                                <div className="border"></div> */}

                                <div className="checkout-item d-flex align-items-center justify-content-between">
                                    <p><b>Total Payment:</b></p>
                                    <p><b>₹ {OrderData?.Order_Amount}</b></p>
                                </div>
                            </div>

                        </div>

                        <div className="border"></div>



                    </div>
                    <div className="row">
                        <h2><br />Customer Profile: <br /><br /></h2>
                        <div className="col-xl-4">
                            <div style={{ width: "80%", borderRight: "1px solid #979696" }}>
                                <p><b>Name</b></p>
                                <p>{OrderData?.Name}</p>
                                <p><b>Phone No</b></p>
                                <p>{OrderData?.Shipping_ContactNumber}</p>
                            </div>
                        </div>
                        <div className="col-xl-4">
                            <p><b>Address</b></p>
                            <p>{OrderData?.Shipping_Address}</p>
                            <p>{OrderData?.Shiping_City}</p>
                            <p>{OrderData?.Shipping_State}</p>
                            <p>{OrderData?.Shipping_Country}</p>
                            <p>{OrderData?.Shipping_PinCode}</p>
                            <p><b>Payment Mode</b></p>
                            <p>{OrderData?.PaymentModeName}</p>
                        </div>
                        <div className="col-xl-4">
                            <div className="whatsapp-area">
                                <div className="row">
                                    <div className="col-md-3">
                                        <img src="/assets/img/WhatsApp.webp" alt="shape-img" style={{ width: "60px" }} />
                                    </div>
                                    <div className="col-md-9">
                                        <div className="checkout-item center">
                                            <h4>Facing Issue?</h4>
                                            <p>Whatsapp for Live Support</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="border"></div>
                    </div>
                </div>
            </div>
        </div>

    </>);
}
export default OrderResponse;